<template>
<div class="chapter">
<div class="inner_page">
<a id="page_xiii"></a>
<h2 class="fm_title">Notes</h2>
<p class="noindent"><span class="dropcap">J</span>apanese names should appear family name first and first name last. I’ve reversed that order for the convenience of English speaking readers and to the irritation of my Japanese friends.</p>
<p class="indent">The interviews are edited. The questions have been deleted and answers edited with as light a touch as possible, commensurate with the meaning being made clear in English while attempting to preserve elements of Japanese character and style. Place names have sometimes been changed to names English speaking readers can identify. For instance, in Japan the battle of Buna is known as the battle of Giruwa. In other places the name in English appears in brackets after the Japanese name. A few Japanese words have been retained.</p>
<p class="indent">Japan has used the metric system since 1924. One centimetre is about two fifths of an inch. One metre is about ten per cent longer than a yard, or 1.09 yards. One kilometre is 1,093 yards. A kilogram is 2.2 pounds. Occasionally the veterans use the old system, where <em class="italic">sho</em> is a unit of volume and <em class="italic">kan</em> a unit of weight.</p>
<p class="indent">Because Second World War Japanese aircraft names were difficult for English speakers to pronounce they were given code names, which appear in brackets after whatever term the veteran used to describe the aircraft. Fighters were given men’s names, bombers and other aircraft were given women’s names. The Mitsubishi G4M bomber, for instance, was called Betty.</p>
<p class="indent">Veterans who I believe had participated in the killing of Australian prisoners of war on Ambon, or who served as guards on the Burma railway, refused to be interviewed.</p>
<a id="page_xvi"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Notes.vue?e1e37168